import { render } from "./HeroiconsOutlineBan.vue?vue&type=template&id=d2c251e8"
const script = {}

import exportComponent from "/home/nginx/domains/panel.vip-mod.net/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineBan.vue"]])

export default __exports__